import { useLocation } from "react-router-dom";
import { PublicChatKitButton } from "./PublicChatKitButton";
import { ErrorBoundary } from "@/components/ui/ErrorBoundary";

/**
 * PublicChatKitButtonWrapper - Wrapper that conditionally renders PublicChatKitButton
 * 
 * This wrapper checks if the current page is public BEFORE rendering PublicChatKitButton.
 * This prevents hooks from being called on non-public pages, avoiding initialization errors.
 * 
 * Public pages: landing, auth, etc. (NOT /dashboard, /admin, /tg)
 */
export function PublicChatKitButtonWrapper() {
  const location = useLocation();

  // Check if current page is public BEFORE rendering component
  const isPublicPage = !location.pathname.startsWith('/dashboard') && 
                       !location.pathname.startsWith('/admin') &&
                       !location.pathname.startsWith('/tg');

  // Don't render component at all on non-public pages (prevents hook calls)
  if (!isPublicPage) {
    return null;
  }

  // Only render PublicChatKitButton on public pages
  // Wrapped in ErrorBoundary to prevent crashes
  return (
    <ErrorBoundary level="component" fallback={null}>
      <PublicChatKitButton />
    </ErrorBoundary>
  );
}

